import {TFunction} from 'i18next';
import {InspectionType, JobCategory, JobType} from '../../store/jobs';

export function getWithInspectionLabel(t: TFunction, withInspection: boolean): string {
    if (withInspection) {
        return t('inspection_withInspection');
    } else {
        return t('inspection_withoutInspection');
    }
}

export function getInspectionTypeLabel(t: TFunction, type?: InspectionType): string {
    if (!type) {
        return t('inspectionType_NoInspection');
    }

    switch (type) {
        case InspectionType.Scheduled: {
            return t('inspectionType_Scheduled');
        }
        case InspectionType.Unscheduled: {
            return t('inspectionType_Unscheduled');
        }
        default:
            throw new Error(`Inspection type ${type} is not supported.`);
    }
}

export function getJobCategoryLabel(t: TFunction, jobCategory: JobCategory): string {
    switch (jobCategory) {
        case JobCategory.Ejob:
            return t('jobCategory_Ejob');
        case JobCategory.FOS:
            return t('jobCategory_FOS');
        default:
            throw new Error(`Job category ${jobCategory} is not supported`);
    }
}
export function getJobTypeLabel(type: JobType, t: TFunction): string {
    switch (type) {
        case JobType.Breakdown: {
            return t('jobType_Breakdown');
        }
        case JobType.Regular: {
            return t('jobType_Regular');
        }
        default:
            throw new Error(`Job type ${type} is not supported.`);
    }
}
